import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Paper from '@material-ui/core/Paper';

const styles = theme => {
    const rootBase = {
        margin: 0,
        background: "#fff",
        '&:hover': {
            color: '#40a9ff'
        },
        '&:hover svg': {
            color: '#40a9ff'
        },
        fontSize: "12px"
    }
    const rootError = {
        ...rootBase,
        color: '#f00'
    }


    return {
        root: rootBase,
        rootError: rootError,
        input:{
        },
        underline: {
            width:"100%",
            minWidth: "250px",
            borderBottom: "none",
            '&:after': {
                borderBottom: "solid 2px #40a9ff",
            },
        },
        MenuItem:{
            height:'auto',
        },
        hoverSwitch:{
            position:'relative',
            '&:hover >.hoverPop':{
                display:'block',
            }
        },
        hoverPop:{
            backgroundColor:'#d32f2f',
            padding: theme.spacing.unit,
            boxShadow: '0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12)',
        },
        popoverText:{
            width:300,
            color:'#fff',
            fontWeight:'bold'
        }
    }
};

// options=[
//     {
//         type:null,
//         value:1,
//         text:'ゆっくりコース（約2週間～ １ヶ月）',
//     },
//     {
//         type:null,
//         value:2,
//         text:'スピードコース（～約1週間）',
//     },
//     {
//         type:'note',
//         value:null,
//         text:'※注意書きをこうやって指定する。',
//     },
// ]

class MySelect extends React.Component {
    state = {
        isChange: false,
        inputValue: '',
        open: false,
    };

    componentWillReceiveProps(nextProps){
        const { defaultValue } = nextProps;
        this.setState({ inputValue: defaultValue });
    }

    handleChange = event => {
        if(event.target.value !== null){
            this.setState({ isChange: true });
            this.setState({ inputValue: event.target.value });
            this.props.handleChange(event.target.value)
        }
    };
    handleClose = () => {
        this.setState({ open: false });
    };
    handleOpen = () => {
        this.setState({ open: true });
    };

    render() {
        const { classes, options, inputProps, error } = this.props;

        return (
            <div className={classes.hoverSwitch} >
                <Select
                    classes={{ root: error?classes.rootError:classes.root, icon: classes.icon }}
                    open={this.state.open}
                    onClose={this.handleClose}
                    onOpen={this.handleOpen}
                    value={this.state.inputValue}
                    onChange={this.handleChange}
                    input={<Input classes={{ root: classes.input, underline: classes.underline }} />}
                    inputProps={inputProps}
                >
                    {
                        (Object.prototype.toString.call(options) === '[object Array]')?
                        options.map((option,key) => (
                            <MenuItem
                                key={key}
                                className={classes.MenuItem}
                                value={option.value}
                                disabled={option.type === 'note'}
                            >
                                <div dangerouslySetInnerHTML={{__html:option.text}} />
                            </MenuItem>
                        )):null
                    }
                </Select>
                {
                    error?
                    <div className="hoverPop">
                        <Paper className={classes.hoverPop}>
                            <div className={classes.popoverText}>
                                {error}
                            </div>
                        </Paper>
                    </div>:null
                }
            </div>
        );
    }
}

MySelect.propTypes = {
    classes: PropTypes.object.isRequired,
    options: PropTypes.array.isRequired,
};

export default withStyles(styles)(MySelect);


// WEBPACK FOOTER //
// ./src/components/MySelect.js